export interface CardLayout {
    title: CARD_LAYOUT_FIELD;
    subtitle: CARD_LAYOUT_FIELD;
    rightBottom: CARD_LAYOUT_FIELD;
}

export enum CARD_LAYOUT_FIELD {
    EMPTY = '',
    NAME = 'name',
    ADDRESS = 'address',
    UPDATED_AT = 'updatedAt',
    OFFER = 'offer'
}


export const DEFAULT_CARD_LAYOUT: CardLayout = {
    title: CARD_LAYOUT_FIELD.NAME,
    subtitle: CARD_LAYOUT_FIELD.OFFER,
    rightBottom: CARD_LAYOUT_FIELD.ADDRESS,
}
